import type React from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const ContentIslands: React.FC<Props> = ({
  className,
  width = 80,
  height = 43,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 80 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_60810_153586)">
        <path
          d="M12 34.8C12 33.1198 12 32.2798 12.327 31.638C12.6146 31.0735 13.0735 30.6146 13.638 30.327C14.2798 30 15.1198 30 16.8 30H63.2C64.8802 30 65.7202 30 66.362 30.327C66.9265 30.6146 67.3854 31.0735 67.673 31.638C68 32.2798 68 33.1198 68 34.8V47.7C68 49.3802 68 50.2202 67.673 50.862C67.3854 51.4265 66.9265 51.8854 66.362 52.173C65.7202 52.5 64.8802 52.5 63.2 52.5H16.8C15.1198 52.5 14.2798 52.5 13.638 52.173C13.0735 51.8854 12.6146 51.4265 12.327 50.862C12 50.2202 12 49.3802 12 47.7V34.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50 36.75C50 37.1642 49.6642 37.5 49.25 37.5H18.75C18.3358 37.5 18 37.1642 18 36.75C18 36.3358 18.3358 36 18.75 36H49.25C49.6642 36 50 36.3358 50 36.75Z"
          fill="#ACBDD3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62 41.25C62 41.6642 61.6642 42 61.25 42H18.75C18.3358 42 18 41.6642 18 41.25C18 40.8358 18.3358 40.5 18.75 40.5H61.25C61.6642 40.5 62 40.8358 62 41.25Z"
          fill="#ACBDD3"
        />
        <path
          d="M12 12.8C12 11.1198 12 10.2798 12.327 9.63803C12.6146 9.07354 13.0735 8.6146 13.638 8.32698C14.2798 8 15.1198 8 16.8 8H63.2C64.8802 8 65.7202 8 66.362 8.32698C66.9265 8.6146 67.3854 9.07354 67.673 9.63803C68 10.2798 68 11.1198 68 12.8V21.2C68 22.8802 68 23.7202 67.673 24.362C67.3854 24.9265 66.9265 25.3854 66.362 25.673C65.7202 26 64.8802 26 63.2 26H16.8C15.1198 26 14.2798 26 13.638 25.673C13.0735 25.3854 12.6146 24.9265 12.327 24.362C12 23.7202 12 22.8802 12 21.2V12.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62 14.75C62 15.1642 61.6642 15.5 61.25 15.5H18.75C18.3358 15.5 18 15.1642 18 14.75C18 14.3358 18.3358 14 18.75 14H61.25C61.6642 14 62 14.3358 62 14.75Z"
          fill="#ACBDD3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50 19.25C50 19.6642 49.6642 20 49.25 20H18.75C18.3358 20 18 19.6642 18 19.25C18 18.8358 18.3358 18.5 18.75 18.5H49.25C49.6642 18.5 50 18.8358 50 19.25Z"
          fill="#ACBDD3"
        />
      </g>
      <defs>
        <clipPath id="clip0_60810_153586">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
